/** OTT object_type of a table's day-long stream (one video, one recording per go-live). */
export const FULL_DAY_STREAM_OBJECT_TYPE = 'FULLDAYSTREAM';

/**
 * State the streamer's mobile app reports for a video: PLAYING = live and playing, PAUSED = interval between
 * matches (still live for viewers), PLAYED = streamed (the stream has ended).
 */
export type PlaybackState = 'PLAYING' | 'PAUSED' | 'PLAYED';

/** One IVS recording session of a video (`videos.recordings`, oldest first). */
export interface VideoRecording {
  readonly recording_id: string;
  readonly playback_url: string;
  readonly started_at: string;
  /** Null until IVS has finished the recording. */
  readonly duration_ms?: number | null;
}

/** Socket payload the gateway broadcasts when a streamer pauses or resumes. */
export interface VideoPlaybackState {
  readonly video_id: number;
  readonly event_id: number | null;
  readonly playback_state: PlaybackState;
  readonly playback_state_updated_at: string;
}

export const VIDEO_PLAYBACK_STATE_MESSAGE = 'VIDEO_PLAYBACK_STATE';

export interface VideoPlaybackStateMessage {
  readonly type: typeof VIDEO_PLAYBACK_STATE_MESSAGE;
  readonly data: VideoPlaybackState;
}

/** Typed socket messages carry `type`; live-score payloads never do. */
export function isTypedSocketMessage(message: unknown): boolean {
  return typeof message === 'object' && message !== null && typeof (message as { type?: unknown }).type === 'string';
}

export function isVideoPlaybackStateMessage(message: unknown): message is VideoPlaybackStateMessage {
  const candidate = message as Partial<{ type: unknown; data: Partial<VideoPlaybackState> }> | null;
  return (
    typeof candidate === 'object' &&
    candidate !== null &&
    candidate.type === VIDEO_PLAYBACK_STATE_MESSAGE &&
    typeof candidate.data?.video_id === 'number'
  );
}
